import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	restrictedProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	restrictedProject: {
		id: 'issue-field-atlas-project-common.restricted.restricted-project',
		defaultMessage: 'Restricted project',
		description: 'Text to indicate that a given project is restricted',
	},
});
export default messages;
